export default __webpack_public_path__ + "static/media/four.8814f6ef.jpeg";